<template>
	<section-entity
		:componentProps="componentProps"
		:componentHandlers="componentHandlers"
		:sectionTitle="sectionTitle"
		:showButtons="showButtons"
		@contact:add="$emit('contact:add')"
		@address:add="$emit('address:add')"
		@identity:add="$emit('identity:add')"
		@fact:add="$emit('fact:add')"
	/>
</template>

<script>
import SectionEntity from "../SectionEntity"

export default {
	name: "SectionHolder",
	components: {
		SectionEntity
	},
	props: {
		componentProps: {
			type: Object
		},
		componentHandlers: {
			type: Object
		},
		showButtons: {
			required: false,
			default: true
		}
	},

	data() {
		return {
			sectionTitle: this.$t("holder")
		}
	},

	methods: {}
}
</script>
